import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import SlideUpTransition from "../fundamentals/SlideUpTransition";
import StarsCloseIconButton from "../fundamentals/StarsCloseIconButton.jsx";
import { useSelector } from "react-redux";
import { selectUserSession } from "../../slices/userSession/userSessionSlice";

const MoreInfoDialog = (props) => {
  const userSession = useSelector(selectUserSession);

  return (
    <Dialog
      className="detail-dialog"
      data-testid="more-info-detail-dialog"
      fullScreen={!props.isDesktopView}
      fullWidth
      maxWidth="md"
      open={!!props.otRequest}
      TransitionComponent={SlideUpTransition}
      keepMounted
      onClose={props.handleMoreInfoDialogClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <StarsCloseIconButton onClick={props.handleMoreInfoDialogClose} />
      </DialogTitle>
      <DialogContent className="detail-dialog-content">
        <DialogContentText component={"div"} id="alert-dialog-slide-description">
          <Grid container>
            <Grid item xs={12} sm={6}>
              <Paper className="detail-dialog-section" elevation={4}>
                <Typography component={"div"}>
                  <Box className="detail-dialog-section-title">Overtime Signup Information</Box>
                </Typography>
                <Grid container>
                  {userSession.eid === props.otRequest.eid && (
                    <>
                      <Grid item xs={6}>
                        <Typography fontWeight={"bold"}>Reference #</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <div className="detail-dialog-right-text">{props.otRequest.referenceNumber}</div>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={6}>
                    <Typography fontWeight={"bold"}>Name</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <div className="detail-dialog-right-text">
                      {props.otRequest.lastName}, {props.otRequest.firstName}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography fontWeight={"bold"}>Scheduled Hours</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <div className="detail-dialog-right-text">
                      {props.otRequest.isOff
                        ? "OFF"
                        : props.otRequest.shifts.map((shift) => shift.start + "-" + shift.end).join(", ")}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography fontWeight={"bold"}>Days Off</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <div className="detail-dialog-right-text">{props.otRequest.daysOff.join(", ")}</div>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography fontWeight={"bold"}>Continuous With Preference</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <div className="detail-dialog-right-text">
                      {props.otRequest.continuousWithType?.split(":")[1]}
                      {props.otRequest.continuousWithTouching ? " (T)" : ""}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography fontWeight={"bold"}>Callout OT Duration Preference</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <div className="detail-dialog-right-text">
                      {Object.values(props.otRequest.calloutOTRank)
                        .filter(Boolean)
                        .map((otRank) => {
                          return (
                            <div key={otRank}>
                              {otRank}
                              <br />
                            </div>
                          );
                        })}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography fontWeight={"bold"}>Callout OT Timing</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <div className="detail-dialog-right-text">
                      {Object.values(props.otRequest.calloutAmPmPreferenceRank)
                        .filter((pref) => pref.preference)
                        .map((pref) => {
                          return pref.preference + (pref.touching ? " (T)" : "");
                        })
                        .join(", ")}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography fontWeight={"bold"}>Will Accept</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <div className="detail-dialog-right-text">{props.otRequest.willAccept ? "Yes" : "No"}</div>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography fontWeight={"bold"}>Waived 45-Minute Minimum</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <div className="detail-dialog-right-text">{props.otRequest.willWave45Min ? "Yes" : "No"}</div>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

MoreInfoDialog.propTypes = {
  otRequest: PropTypes.object.isRequired,
  handleMoreInfoDialogClose: PropTypes.func.isRequired,
  isDesktopView: PropTypes.bool.isRequired,
};

export default MoreInfoDialog;
